import { baseApi as api } from "./baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    findTenantByIdTenantsIdGet: build.query<
      FindTenantByIdTenantsIdGetApiResponse,
      FindTenantByIdTenantsIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/tenants/${queryArg.id}` }),
    }),
    listZonesZonesGet: build.query<
      ListZonesZonesGetApiResponse,
      ListZonesZonesGetApiArg
    >({
      query: () => ({ url: `/zones` }),
    }),
    createZoneZonesPost: build.mutation<
      CreateZoneZonesPostApiResponse,
      CreateZoneZonesPostApiArg
    >({
      query: (queryArg) => ({
        url: `/zones`,
        method: "POST",
        body: queryArg.zoneCreate,
      }),
    }),
    listZoneTreeZonesTreeGet: build.query<
      ListZoneTreeZonesTreeGetApiResponse,
      ListZoneTreeZonesTreeGetApiArg
    >({
      query: () => ({ url: `/zones/tree` }),
    }),
    findZoneByIdZonesIdGet: build.query<
      FindZoneByIdZonesIdGetApiResponse,
      FindZoneByIdZonesIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}` }),
    }),
    updateZoneZonesIdPatch: build.mutation<
      UpdateZoneZonesIdPatchApiResponse,
      UpdateZoneZonesIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/zones/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.zoneUpdate,
      }),
    }),
    deleteZoneZonesIdDelete: build.mutation<
      DeleteZoneZonesIdDeleteApiResponse,
      DeleteZoneZonesIdDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}`, method: "DELETE" }),
    }),
    zoneParentZonesIdParentGet: build.query<
      ZoneParentZonesIdParentGetApiResponse,
      ZoneParentZonesIdParentGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}/parent` }),
    }),
    listZoneChildrenZonesIdChildrenGet: build.query<
      ListZoneChildrenZonesIdChildrenGetApiResponse,
      ListZoneChildrenZonesIdChildrenGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}/children` }),
    }),
    listZoneDescendantsZonesIdDescendantsGet: build.query<
      ListZoneDescendantsZonesIdDescendantsGetApiResponse,
      ListZoneDescendantsZonesIdDescendantsGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}/descendants` }),
    }),
    listZoneAncestorsZonesIdAncestorsGet: build.query<
      ListZoneAncestorsZonesIdAncestorsGetApiResponse,
      ListZoneAncestorsZonesIdAncestorsGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}/ancestors` }),
    }),
    zoneTenantZonesIdTenantGet: build.query<
      ZoneTenantZonesIdTenantGetApiResponse,
      ZoneTenantZonesIdTenantGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.id}/tenant` }),
    }),
    listSubjectsSubjectsGet: build.query<
      ListSubjectsSubjectsGetApiResponse,
      ListSubjectsSubjectsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects`,
        params: {
          path: queryArg.path,
          exclude_assigned_to_device_type: queryArg.excludeAssignedToDeviceType,
          embed: queryArg.embed,
        },
      }),
    }),
    createSubjectSubjectsPost: build.mutation<
      CreateSubjectSubjectsPostApiResponse,
      CreateSubjectSubjectsPostApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects`,
        method: "POST",
        body: queryArg.subjectCreate,
      }),
    }),
    findSubjectByIdSubjectsIdGet: build.query<
      FindSubjectByIdSubjectsIdGetApiResponse,
      FindSubjectByIdSubjectsIdGetApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.id}`,
        params: {
          embed: queryArg.embed,
        },
      }),
    }),
    updateSubjectSubjectsIdPatch: build.mutation<
      UpdateSubjectSubjectsIdPatchApiResponse,
      UpdateSubjectSubjectsIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.subjectUpdate,
        params: {
          embed: queryArg.embed,
        },
      }),
    }),
    deleteSubjectSubjectsIdDelete: build.mutation<
      DeleteSubjectSubjectsIdDeleteApiResponse,
      DeleteSubjectSubjectsIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    listDevicesDevicesGet: build.query<
      ListDevicesDevicesGetApiResponse,
      ListDevicesDevicesGetApiArg
    >({
      query: (queryArg) => ({
        url: `/devices`,
        params: {
          path: queryArg.path,
          types: queryArg.types,
          embed: queryArg.embed,
        },
      }),
    }),
    registerOrCreateADeviceDevicesPost: build.mutation<
      RegisterOrCreateADeviceDevicesPostApiResponse,
      RegisterOrCreateADeviceDevicesPostApiArg
    >({
      query: (queryArg) => ({
        url: `/devices`,
        method: "POST",
        body: queryArg.deviceCreateOrRegister,
      }),
    }),
    findDeviceByIdDevicesIdGet: build.query<
      FindDeviceByIdDevicesIdGetApiResponse,
      FindDeviceByIdDevicesIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/devices/${queryArg.id}` }),
    }),
    updateDeviceDevicesIdPatch: build.mutation<
      UpdateDeviceDevicesIdPatchApiResponse,
      UpdateDeviceDevicesIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/devices/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.deviceUpdate,
      }),
    }),
    deleteDeviceDevicesIdDelete: build.mutation<
      DeleteDeviceDevicesIdDeleteApiResponse,
      DeleteDeviceDevicesIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/devices/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    listUsersUsersGet: build.query<
      ListUsersUsersGetApiResponse,
      ListUsersUsersGetApiArg
    >({
      query: (queryArg) => ({
        url: `/users`,
        params: {
          embed: queryArg.embed,
        },
      }),
    }),
    createUserUsersPost: build.mutation<
      CreateUserUsersPostApiResponse,
      CreateUserUsersPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users`,
        method: "POST",
        body: queryArg.userCreate,
      }),
    }),
    findUserByIdUsersIdGet: build.query<
      FindUserByIdUsersIdGetApiResponse,
      FindUserByIdUsersIdGetApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.id}`,
        params: {
          embed: queryArg.embed,
        },
      }),
    }),
    updateUserUsersIdPatch: build.mutation<
      UpdateUserUsersIdPatchApiResponse,
      UpdateUserUsersIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.userUpdate,
      }),
    }),
    deleteUserUsersIdDelete: build.mutation<
      DeleteUserUsersIdDeleteApiResponse,
      DeleteUserUsersIdDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/users/${queryArg.id}`, method: "DELETE" }),
    }),
    resetPasswordUsersIdResetPasswordPost: build.mutation<
      ResetPasswordUsersIdResetPasswordPostApiResponse,
      ResetPasswordUsersIdResetPasswordPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.id}/reset-password`,
        method: "POST",
      }),
    }),
    listUserZonesUsersIdZonesGet: build.query<
      ListUserZonesUsersIdZonesGetApiResponse,
      ListUserZonesUsersIdZonesGetApiArg
    >({
      query: (queryArg) => ({ url: `/users/${queryArg.id}/zones` }),
    }),
    addUserZoneAssociationUsersUserIdZonesZoneIdPost: build.mutation<
      AddUserZoneAssociationUsersUserIdZonesZoneIdPostApiResponse,
      AddUserZoneAssociationUsersUserIdZonesZoneIdPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/zones/${queryArg.zoneId}`,
        method: "POST",
      }),
    }),
    removeUserZoneAssociationUsersUserIdZonesZoneIdDelete: build.mutation<
      RemoveUserZoneAssociationUsersUserIdZonesZoneIdDeleteApiResponse,
      RemoveUserZoneAssociationUsersUserIdZonesZoneIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/zones/${queryArg.zoneId}`,
        method: "DELETE",
      }),
    }),
    liveMonitoringLiveMonitoringGet: build.query<
      LiveMonitoringLiveMonitoringGetApiResponse,
      LiveMonitoringLiveMonitoringGetApiArg
    >({
      query: (queryArg) => ({
        url: `/live-monitoring`,
        params: {
          zones: queryArg.zones,
          device_types: queryArg.deviceTypes,
          include_unassigned_devices: queryArg.includeUnassignedDevices,
        },
      }),
    }),
    generateReportsReportsGet: build.query<
      GenerateReportsReportsGetApiResponse,
      GenerateReportsReportsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/reports`,
        params: {
          subjects: queryArg.subjects,
          report_date: queryArg.reportDate,
        },
      }),
    }),
    listSessionsSessionsGet: build.query<
      ListSessionsSessionsGetApiResponse,
      ListSessionsSessionsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/sessions`,
        params: {
          type: queryArg["type"],
          subject_id: queryArg.subjectId,
          from: queryArg["from"],
          to: queryArg.to,
          state: queryArg.state,
          sort: queryArg.sort,
          limit: queryArg.limit,
          time_in_bed: queryArg.timeInBed,
          time_asleep: queryArg.timeAsleep,
        },
      }),
    }),
    findSessionSessionsSessionIdGet: build.query<
      FindSessionSessionsSessionIdGetApiResponse,
      FindSessionSessionsSessionIdGetApiArg
    >({
      query: (queryArg) => ({
        url: `/sessions/${queryArg.sessionId}`,
        params: {
          include_epoch_data: queryArg.includeEpochData,
        },
      }),
    }),
    listNotificationHandlersNotificationHandlersGet: build.query<
      ListNotificationHandlersNotificationHandlersGetApiResponse,
      ListNotificationHandlersNotificationHandlersGetApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-handlers`,
        params: {
          zone_id: queryArg.zoneId,
          type: queryArg["type"],
        },
      }),
    }),
    createNotificationHandlerNotificationHandlersPost: build.mutation<
      CreateNotificationHandlerNotificationHandlersPostApiResponse,
      CreateNotificationHandlerNotificationHandlersPostApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-handlers`,
        method: "POST",
        body: queryArg.notificationHandlerCreate,
      }),
    }),
    findNotificationHandlerNotificationHandlersIdGet: build.query<
      FindNotificationHandlerNotificationHandlersIdGetApiResponse,
      FindNotificationHandlerNotificationHandlersIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/notification-handlers/${queryArg.id}` }),
    }),
    updateNotificationHandlerNotificationHandlersIdPatch: build.mutation<
      UpdateNotificationHandlerNotificationHandlersIdPatchApiResponse,
      UpdateNotificationHandlerNotificationHandlersIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-handlers/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.notificationHandlerUpdateModels,
      }),
    }),
    deleteNotificationHandlerNotificationHandlersIdDelete: build.mutation<
      DeleteNotificationHandlerNotificationHandlersIdDeleteApiResponse,
      DeleteNotificationHandlerNotificationHandlersIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-handlers/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    testNotificationHandlerNotificationHandlersIdTestPost: build.mutation<
      TestNotificationHandlerNotificationHandlersIdTestPostApiResponse,
      TestNotificationHandlerNotificationHandlersIdTestPostApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-handlers/${queryArg.id}/test`,
        method: "POST",
        body: queryArg.notificationHandlerTest,
      }),
    }),
    listRulesRulesGet: build.query<
      ListRulesRulesGetApiResponse,
      ListRulesRulesGetApiArg
    >({
      query: (queryArg) => ({
        url: `/rules`,
        params: {
          entity_id: queryArg.entityId,
          type: queryArg["type"],
        },
      }),
    }),
    createRuleRulesPost: build.mutation<
      CreateRuleRulesPostApiResponse,
      CreateRuleRulesPostApiArg
    >({
      query: (queryArg) => ({
        url: `/rules`,
        method: "POST",
        body: queryArg.ruleCreateModels,
      }),
    }),
    listRulePresetsRulesPresetsGet: build.query<
      ListRulePresetsRulesPresetsGetApiResponse,
      ListRulePresetsRulesPresetsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/rules/presets`,
        params: {
          rule_type: queryArg.ruleType,
          rule_preset_type: queryArg.rulePresetType,
        },
      }),
    }),
    findRuleRulesIdGet: build.query<
      FindRuleRulesIdGetApiResponse,
      FindRuleRulesIdGetApiArg
    >({
      query: (queryArg) => ({ url: `/rules/${queryArg.id}` }),
    }),
    updateRuleRulesIdPatch: build.mutation<
      UpdateRuleRulesIdPatchApiResponse,
      UpdateRuleRulesIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/rules/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.ruleUpdateModels,
      }),
    }),
    deleteRuleRulesIdDelete: build.mutation<
      DeleteRuleRulesIdDeleteApiResponse,
      DeleteRuleRulesIdDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/rules/${queryArg.id}`, method: "DELETE" }),
    }),
    listLogsNotificationLogsGet: build.query<
      ListLogsNotificationLogsGetApiResponse,
      ListLogsNotificationLogsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/notification-logs`,
        params: {
          entity_id: queryArg.entityId,
          limit: queryArg.limit,
          from: queryArg["from"],
          to: queryArg.to,
          starting_after: queryArg.startingAfter,
          ending_before: queryArg.endingBefore,
          sort: queryArg.sort,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type FindTenantByIdTenantsIdGetApiResponse =
  /** status 200 Successful Response */ ResponseTenantPublic;
export type FindTenantByIdTenantsIdGetApiArg = {
  id: string;
};
export type ListZonesZonesGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListZonesZonesGetApiArg = void;
export type CreateZoneZonesPostApiResponse =
  /** status 201 Successful Response */ ResponseZone;
export type CreateZoneZonesPostApiArg = {
  zoneCreate: ZoneCreate;
};
export type ListZoneTreeZonesTreeGetApiResponse =
  /** status 200 Successful Response */ ListResponseZoneWithChildren;
export type ListZoneTreeZonesTreeGetApiArg = void;
export type FindZoneByIdZonesIdGetApiResponse =
  /** status 200 Successful Response */ ResponseZone;
export type FindZoneByIdZonesIdGetApiArg = {
  id: string;
};
export type UpdateZoneZonesIdPatchApiResponse =
  /** status 200 Successful Response */ ResponseZone;
export type UpdateZoneZonesIdPatchApiArg = {
  id: string;
  zoneUpdate: ZoneUpdate;
};
export type DeleteZoneZonesIdDeleteApiResponse = unknown;
export type DeleteZoneZonesIdDeleteApiArg = {
  id: string;
};
export type ZoneParentZonesIdParentGetApiResponse =
  /** status 200 Successful Response */ ResponseZone;
export type ZoneParentZonesIdParentGetApiArg = {
  id: string;
};
export type ListZoneChildrenZonesIdChildrenGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListZoneChildrenZonesIdChildrenGetApiArg = {
  id: string;
};
export type ListZoneDescendantsZonesIdDescendantsGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListZoneDescendantsZonesIdDescendantsGetApiArg = {
  id: string;
};
export type ListZoneAncestorsZonesIdAncestorsGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListZoneAncestorsZonesIdAncestorsGetApiArg = {
  id: string;
};
export type ZoneTenantZonesIdTenantGetApiResponse =
  /** status 200 Successful Response */ ResponseTenant;
export type ZoneTenantZonesIdTenantGetApiArg = {
  id: string;
};
export type ListSubjectsSubjectsGetApiResponse =
  /** status 200 Successful Response */ ListResponseSubject;
export type ListSubjectsSubjectsGetApiArg = {
  /** Filter subjects based on the zone path.
        Path nodes should be separated by ".", use ".*" to include subjects from all descendant zones.
    
        Examples:
        - "zone_00default" will return all direct subjects in the zone with id "zone_00default"
        - "zone_00default.*" will return all subjects fom the zone with id "zone_00default" and all descendant
        zones (i.e. "zone_00default.zone_level2.zone_level3")
         */
  path?: string | null;
  excludeAssignedToDeviceType?: DeviceType | null;
  embed?: SubjectEmbed[];
};
export type CreateSubjectSubjectsPostApiResponse =
  /** status 201 Successful Response */ ResponseSubject;
export type CreateSubjectSubjectsPostApiArg = {
  subjectCreate: SubjectCreate;
};
export type FindSubjectByIdSubjectsIdGetApiResponse =
  /** status 200 Successful Response */ ResponseSubject;
export type FindSubjectByIdSubjectsIdGetApiArg = {
  id: string;
  embed?: SubjectEmbed[];
};
export type UpdateSubjectSubjectsIdPatchApiResponse =
  /** status 200 Successful Response */ ResponseSubject;
export type UpdateSubjectSubjectsIdPatchApiArg = {
  id: string;
  embed?: SubjectEmbed[];
  subjectUpdate: SubjectUpdate;
};
export type DeleteSubjectSubjectsIdDeleteApiResponse = unknown;
export type DeleteSubjectSubjectsIdDeleteApiArg = {
  id: string;
};
export type ListDevicesDevicesGetApiResponse =
  /** status 200 Successful Response */ ListResponseDevice;
export type ListDevicesDevicesGetApiArg = {
  /** Filter devices based on the zone path.
        Path nodes should be separated by ".", use ".*" to include devices from all descendant zones.
    
        Examples:
        - "zone_00default" will return all direct devices in the zone with id "zone_00default"
        - "zone_00default.*" will return all devices fom the zone with id "zone_00default" and all descendant
        zones (i.e. "zone_00default.zone_level2.zone_level3")
         */
  path?: string | null;
  /** Type of device */
  types?: DeviceType[];
  embed?: DeviceEmbed[];
};
export type RegisterOrCreateADeviceDevicesPostApiResponse =
  /** status 201 Successful Response */ ResponseDevice;
export type RegisterOrCreateADeviceDevicesPostApiArg = {
  deviceCreateOrRegister:
    | DeviceGenericCreate
    | DeviceVitalThingsGuardianH10Register
    | DeviceVitalThingsSomnofySm100Register;
};
export type FindDeviceByIdDevicesIdGetApiResponse =
  /** status 200 Successful Response */ ResponseDevice;
export type FindDeviceByIdDevicesIdGetApiArg = {
  id: string;
};
export type UpdateDeviceDevicesIdPatchApiResponse =
  /** status 200 Successful Response */ ResponseDevice;
export type UpdateDeviceDevicesIdPatchApiArg = {
  id: string;
  deviceUpdate:
    | DeviceGenericUpdate
    | DeviceVitalThingsGuardianH10Update
    | DeviceVitalThingsSomnofySm100Update;
};
export type DeleteDeviceDevicesIdDeleteApiResponse = unknown;
export type DeleteDeviceDevicesIdDeleteApiArg = {
  id: string;
};
export type ListUsersUsersGetApiResponse =
  /** status 200 Successful Response */ ListResponseUser;
export type ListUsersUsersGetApiArg = {
  embed?: UserEmbed[];
};
export type CreateUserUsersPostApiResponse =
  /** status 201 Successful Response */ ResponseUser;
export type CreateUserUsersPostApiArg = {
  userCreate: UserCreate;
};
export type FindUserByIdUsersIdGetApiResponse =
  /** status 200 Successful Response */ ResponseUser;
export type FindUserByIdUsersIdGetApiArg = {
  id: string;
  embed?: UserEmbed[];
};
export type UpdateUserUsersIdPatchApiResponse =
  /** status 201 Successful Response */ ResponseUser;
export type UpdateUserUsersIdPatchApiArg = {
  id: string;
  userUpdate: UserUpdate;
};
export type DeleteUserUsersIdDeleteApiResponse = unknown;
export type DeleteUserUsersIdDeleteApiArg = {
  id: string;
};
export type ResetPasswordUsersIdResetPasswordPostApiResponse =
  /** status 200 Successful Response */ ActionResponse;
export type ResetPasswordUsersIdResetPasswordPostApiArg = {
  id: string;
};
export type ListUserZonesUsersIdZonesGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListUserZonesUsersIdZonesGetApiArg = {
  id: string;
};
export type AddUserZoneAssociationUsersUserIdZonesZoneIdPostApiResponse =
  unknown;
export type AddUserZoneAssociationUsersUserIdZonesZoneIdPostApiArg = {
  userId: string;
  zoneId: string;
};
export type RemoveUserZoneAssociationUsersUserIdZonesZoneIdDeleteApiResponse =
  unknown;
export type RemoveUserZoneAssociationUsersUserIdZonesZoneIdDeleteApiArg = {
  userId: string;
  zoneId: string;
};
export type LiveMonitoringLiveMonitoringGetApiResponse =
  /** status 200 Successful Response */ ListResponseLiveMonitorItem;
export type LiveMonitoringLiveMonitoringGetApiArg = {
  zones: string[];
  deviceTypes: DeviceType[];
  includeUnassignedDevices?: boolean;
};
export type GenerateReportsReportsGetApiResponse =
  /** status 200 Successful Response */ ListResponseReport;
export type GenerateReportsReportsGetApiArg = {
  subjects: string[];
  /** Date of the report in yyyy-mm-dd format */
  reportDate: string;
};
export type ListSessionsSessionsGetApiResponse =
  /** status 200 Successful Response */ ListResponseVitalThingsSomnofySm100Session;
export type ListSessionsSessionsGetApiArg = {
  type: SessionType;
  subjectId: string;
  from?: string | null;
  to?: string | null;
  state?: SessionState | null;
  sort?: Sort;
  limit?: number;
  timeInBed?: string;
  timeAsleep?: string;
};
export type FindSessionSessionsSessionIdGetApiResponse =
  /** status 200 Successful Response */ ResponseVitalThingsSomnofySm100Session;
export type FindSessionSessionsSessionIdGetApiArg = {
  sessionId: string;
  includeEpochData?: boolean;
};
export type ListNotificationHandlersNotificationHandlersGetApiResponse =
  /** status 200 Successful Response */ ListResponseNotificationHandler;
export type ListNotificationHandlersNotificationHandlersGetApiArg = {
  /**
   */
  zoneId: string;
  type?: NotificationHandlerType | null;
};
export type CreateNotificationHandlerNotificationHandlersPostApiResponse =
  /** status 201 Successful Response */ ReponseNotificationHandler;
export type CreateNotificationHandlerNotificationHandlersPostApiArg = {
  notificationHandlerCreate: NotificationHandlerCreate;
};
export type FindNotificationHandlerNotificationHandlersIdGetApiResponse =
  /** status 200 Successful Response */ ReponseNotificationHandler;
export type FindNotificationHandlerNotificationHandlersIdGetApiArg = {
  id: string;
};
export type UpdateNotificationHandlerNotificationHandlersIdPatchApiResponse =
  /** status 200 Successful Response */ ReponseNotificationHandler;
export type UpdateNotificationHandlerNotificationHandlersIdPatchApiArg = {
  id: string;
  notificationHandlerUpdateModels: NotificationHandlerUpdateModels;
};
export type DeleteNotificationHandlerNotificationHandlersIdDeleteApiResponse =
  unknown;
export type DeleteNotificationHandlerNotificationHandlersIdDeleteApiArg = {
  id: string;
};
export type TestNotificationHandlerNotificationHandlersIdTestPostApiResponse =
  /** status 200 Successful Response */ ResponseNotificationHandlerTestResponse;
export type TestNotificationHandlerNotificationHandlersIdTestPostApiArg = {
  id: string;
  notificationHandlerTest: NotificationHandlerTest;
};
export type ListRulesRulesGetApiResponse =
  /** status 200 Successful Response */ ListResponseRule;
export type ListRulesRulesGetApiArg = {
  entityId: string;
  type?: RuleType | null;
};
export type CreateRuleRulesPostApiResponse =
  /** status 201 Successful Response */ ReponseMonitoringRule;
export type CreateRuleRulesPostApiArg = {
  ruleCreateModels: RuleCreateModels;
};
export type ListRulePresetsRulesPresetsGetApiResponse =
  /** status 200 Successful Response */ ListResponseRulePreset;
export type ListRulePresetsRulesPresetsGetApiArg = {
  ruleType: RuleType;
  rulePresetType: RulePresetType;
};
export type FindRuleRulesIdGetApiResponse =
  /** status 200 Successful Response */ ReponseMonitoringRule;
export type FindRuleRulesIdGetApiArg = {
  id: string;
};
export type UpdateRuleRulesIdPatchApiResponse =
  /** status 200 Successful Response */ ReponseMonitoringRule;
export type UpdateRuleRulesIdPatchApiArg = {
  id: string;
  ruleUpdateModels: RuleUpdateModels;
};
export type DeleteRuleRulesIdDeleteApiResponse = unknown;
export type DeleteRuleRulesIdDeleteApiArg = {
  id: string;
};
export type ListLogsNotificationLogsGetApiResponse =
  /** status 200 Successful Response */ ListResponseNotificationLog;
export type ListLogsNotificationLogsGetApiArg = {
  /** The entity to filter for, either zone_id, subject_id or device_id */
  entityId: string;
  /** A limit on the number of objects to be returned, between 1 and 100. */
  limit?: number;
  /** From time in ISO8601 format */
  from?: string | null;
  /** To time in ISO8601 format */
  to?: string | null;
  /** A cursor for use in pagination. starting_after is an object ID that defines your place in the list. For instance, if you make a list request and receive 100 objects, ending with obj_foo, your subsequent call can include starting_after=obj_foo in order to fetch the next page of the list. */
  startingAfter?: string | null;
  /** A cursor for use in pagination. ending_before is an object ID that defines your place in the list. For instance, if you make a list request and receive 100 objects, starting with obj_bar, your subsequent call can include ending_before=obj_bar in order to fetch the previous page of the list. */
  endingBefore?: string | null;
  sort?: Sort;
};
export type Entity = "subject" | "user" | "zone";
export type ValueType = "string" | "integer" | "float" | "datetime";
export type DropdownOption = {
  name: {
    [key: string]: string;
  };
  value: string;
};
export type CustomDropdownField = {
  id?: string;
  key: string;
  entity: Entity;
  required: boolean;
  title: {
    [key: string]: string;
  };
  info: {
    [key: string]: string;
  };
  type: "dropdown";
  value_type: ValueType;
  placeholder: {
    [key: string]: string;
  };
  options: DropdownOption[];
  default?: string | number | number | null;
};
export type CustomTextinputField = {
  id?: string;
  key: string;
  entity: Entity;
  required: boolean;
  title: {
    [key: string]: string;
  };
  info: {
    [key: string]: string;
  };
  type: "textinput";
  value_type: "string";
  placeholder: {
    [key: string]: string;
  };
  default?: string | null;
};
export type CustomSliderField = {
  id?: string;
  key: string;
  entity: Entity;
  required: boolean;
  title: {
    [key: string]: string;
  };
  info: {
    [key: string]: string;
  };
  type: "slider";
  value_type: "float" | "integer";
  min: number | number;
  max: number | number;
  step_size?: number | number | null;
  default?: number | number | null;
};
export type TenantPublic = {
  id: string;
  name: string;
  custom_fields?:
    | (CustomDropdownField | CustomTextinputField | CustomSliderField)[]
    | null;
};
export type ResponseTenantPublic = {
  data?: TenantPublic;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type NightReportTimes = {
  start?: string;
  end?: string;
};
export type ZoneSettings = {
  night_report_times?: NightReportTimes | null;
};
export type Zone = {
  id: string;
  object?: "zone";
  tenant_id: string;
  parent_id?: string | null;
  path: string;
  level?: number | null;
  name: string;
  description?: string | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
  settings?: ZoneSettings | null;
  created_at: string;
  updated_at: string;
};
export type ListResponseZone = {
  object?: "list";
  data?: Zone[];
};
export type ResponseZone = {
  data?: Zone;
};
export type ZoneCreate = {
  parent_id?: string | null;
  name: string;
  description?: string | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
  settings?: ZoneSettings | null;
};
export type ZoneWithChildren = {
  id: string;
  object?: "zone";
  tenant_id: string;
  parent_id?: string | null;
  path: string;
  level?: number | null;
  name: string;
  description?: string | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
  settings?: ZoneSettings | null;
  children?: ZoneWithChildren[];
  created_at: string;
  updated_at: string;
};
export type ListResponseZoneWithChildren = {
  object?: "list";
  data?: ZoneWithChildren[];
};
export type ZoneUpdate = {
  name?: string | null;
  description?: string | null;
  metadata?: {
    [key: string]: any;
  };
  settings?: ZoneSettings | null;
};
export type Tenant = {
  id: string;
  object?: "tenant";
  name: string;
  description?: string | null;
  custom_fields?:
    | (CustomDropdownField | CustomTextinputField | CustomSliderField)[]
    | null;
  metadata?: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
};
export type ResponseTenant = {
  data?: Tenant;
};
export type Sex = "male" | "female";
export type EmbeddedSubject = {
  object?: "subject";
  data: Subject;
};
export type DeviceGeneric = {
  /** Each resource has an id element which contains the "logical id" of the resource assigned by the
            server responsible for storing it. Resources always have a known logical id except for a few special cases
            (e.g. when a new resource is being sent to a server to assign a logical id in the create interaction). The
            logical id is unique within the space of all resources of the same type on the same server. Once assigned by
            the server, the id is never changed.
             */
  id: string;
  object?: "device.generic";
  type: "generic";
  virtual: boolean;
  manufacturer?: string | null;
  product?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  name?: string | null;
  /** Device notes and comments */
  note?: string | null;
  tenant_id?: string | null;
  zone_id?: string | null;
  path?: string | null;
  path_level?: number | null;
  subject_id?: string | null;
  subject?: EmbeddedSubject | null;
  metadata?: {
    [key: string]: any;
  };
};
export type VitalThingsSomnofySm100SettingsUserTimeFormat = "12" | "24";
export type VitalThingsSomnofySm100SettingsUserTime = {
  format?: VitalThingsSomnofySm100SettingsUserTimeFormat;
  timezone?: string;
};
export type VitalThingsSomnofySm100SettingsUserDisplayMode =
  | "normal"
  | "circle"
  | "off";
export type VitalThingsSomnofySm100SettingsUserDisplay = {
  mode?: VitalThingsSomnofySm100SettingsUserDisplayMode;
  intensity?: number;
};
export type VitalThingsSomnofySm100SettingsUserAudio = {
  enabled?: boolean;
};
export type VitalThingsSomnofySm100SettingsUserRadar = {
  sensitivity?: number;
  distance_limit?: number;
};
export type TimeSpan = {
  start: string;
  end: string;
};
export type VitalThingsSomnofySm100SettingsUserScheduleItem = {
  enabled?: boolean;
  enable_session?: boolean;
  timespan?: TimeSpan;
};
export type VitalThingsSomnofySm100SettingsUserExternalDeviceBleItem = {
  name?: string;
};
export type VitalThingsSomnofySm100SettingsUserExternalDevices = {
  ble?: VitalThingsSomnofySm100SettingsUserExternalDeviceBleItem[];
};
export type VitalThingsSomnofySm100SettingsUser = {
  time?: VitalThingsSomnofySm100SettingsUserTime;
  display?: VitalThingsSomnofySm100SettingsUserDisplay;
  audio?: VitalThingsSomnofySm100SettingsUserAudio;
  radar?: VitalThingsSomnofySm100SettingsUserRadar;
  schedule?: VitalThingsSomnofySm100SettingsUserScheduleItem[];
  external_devices?: VitalThingsSomnofySm100SettingsUserExternalDevices;
};
export type VitalThingsSomnofySm100SettingsDevice = {
  movement_alarm?: boolean;
  live_sensor_state_enabled_until?: string;
};
export type VitalThingsSomnofySm100Settings = {
  user?: VitalThingsSomnofySm100SettingsUser;
  device?: VitalThingsSomnofySm100SettingsDevice;
};
export type DeviceVitalThingsSomnofySm100 = {
  /** Each resource has an id element which contains the "logical id" of the resource assigned by the
            server responsible for storing it. Resources always have a known logical id except for a few special cases
            (e.g. when a new resource is being sent to a server to assign a logical id in the create interaction). The
            logical id is unique within the space of all resources of the same type on the same server. Once assigned by
            the server, the id is never changed.
             */
  id: string;
  object?: "device.vitalthings-somnofy-sm100";
  type: "vitalthings-somnofy-sm100";
  virtual: boolean;
  manufacturer?: string | null;
  product?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  name?: string | null;
  /** Device notes and comments */
  note?: string | null;
  tenant_id?: string | null;
  zone_id?: string | null;
  path?: string | null;
  path_level?: number | null;
  subject_id?: string | null;
  subject?: EmbeddedSubject | null;
  metadata?: {
    [key: string]: any;
  };
  settings?: VitalThingsSomnofySm100Settings | null;
  latest_connectivity_event_at?: string | null;
  online?: boolean | null;
};
export type VitalThingsGuardianH10SettingsUser = {
  time?: VitalThingsSomnofySm100SettingsUserTime;
  radar?: VitalThingsSomnofySm100SettingsUserRadar;
  schedule?: VitalThingsSomnofySm100SettingsUserScheduleItem[];
};
export type VitalThingsGuardianH10Settings = {
  user?: VitalThingsGuardianH10SettingsUser;
};
export type DeviceVitalThingsGuardianH10 = {
  /** Each resource has an id element which contains the "logical id" of the resource assigned by the
            server responsible for storing it. Resources always have a known logical id except for a few special cases
            (e.g. when a new resource is being sent to a server to assign a logical id in the create interaction). The
            logical id is unique within the space of all resources of the same type on the same server. Once assigned by
            the server, the id is never changed.
             */
  id: string;
  object?: "device.vitalthings-guardian-h10";
  type: "vitalthings-guardian-h10";
  virtual: boolean;
  manufacturer?: string | null;
  product?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  name?: string | null;
  /** Device notes and comments */
  note?: string | null;
  tenant_id?: string | null;
  zone_id?: string | null;
  path?: string | null;
  path_level?: number | null;
  subject_id?: string | null;
  subject?: EmbeddedSubject | null;
  metadata?: {
    [key: string]: any;
  };
  settings?: VitalThingsGuardianH10Settings | null;
  latest_connectivity_event_at?: string | null;
  online?: boolean | null;
};
export type EmbeddedDevices = {
  object?: "list";
  data?: (
    | DeviceGeneric
    | DeviceVitalThingsSomnofySm100
    | DeviceVitalThingsGuardianH10
  )[];
};
export type Subject = {
  /** Each resource has an id element which contains the "logical id" of the resource assigned by the
            server responsible for storing it. Resources always have a known logical id except for a few special cases
            (e.g. when a new resource is being sent to a server to assign a logical id in the create interaction). The
            logical id is unique within the space of all resources of the same type on the same server. Once assigned by
            the server, the id is never changed.
             */
  id: string;
  object?: "subject";
  tenant_id: string;
  zone_id: string;
  path: string;
  level?: number | null;
  custom_fields?: {
    [key: string]: any;
  } | null;
  /** An identifier for this patient. This is a business identifier, not a resource identifier. Subjects
            should almost always be assigned specific alphanumerical identifiers. */
  identifier: string;
  /** A name associated with the individual. */
  name?: string | null;
  sex?: Sex | null;
  /** The year of birth for the individual. */
  birth_year?: number | null;
  height?: number | null;
  weight?: number | null;
  /** Whether this subject record is in active use.
                Many systems use this property to mark as non-current subjects, such as those that have not been seen for a
                period of time based on an organization's business rules. It is often used to filter subject lists to
                exclude inactive subjects.
                Deceased subjects may also be marked as inactive for the same reasons, but may be active for some time after
                death. */
  active?: boolean;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
  devices?: EmbeddedDevices | null;
};
export type ListResponseSubject = {
  object?: "list";
  data?: Subject[];
};
export type DeviceType =
  | "generic"
  | "vitalthings-somnofy-sm100"
  | "vitalthings-guardian-h10";
export type SubjectEmbed = "devices";
export type ResponseSubject = {
  data?: Subject;
};
export type SubjectCreate = {
  zone_id: string;
  /** An identifier for this patient. This is a business identifier, not a resource identifier. Subjects
            should almost always be assigned specific alphanumerical identifiers. */
  identifier: string;
  /** A name associated with the individual. */
  name?: string | null;
  sex?: Sex | null;
  /** The year of birth for the individual. */
  birth_year?: number | null;
  height?: number | null;
  weight?: number | null;
  /** Whether this subject record is in active use.
                Many systems use this property to mark as non-current subjects, such as those that have not been seen for a
                period of time based on an organization's business rules. It is often used to filter subject lists to
                exclude inactive subjects.
                Deceased subjects may also be marked as inactive for the same reasons, but may be active for some time after
                death. */
  active?: boolean;
  custom_fields?: {
    [key: string]: any;
  } | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
};
export type SubjectUpdate = {
  zone_id?: string | null;
  /** An identifier for this patient. This is a business identifier, not a resource identifier. Subjects
            should almost always be assigned specific alphanumerical identifiers. */
  identifier?: string | null;
  /** A name associated with the individual. */
  name?: string | null;
  sex?: Sex | null;
  /** The year of birth for the individual. */
  birth_year?: number | null;
  height?: number | null;
  weight?: number | null;
  /** Whether this subject record is in active use.
                Many systems use this property to mark as non-current subjects, such as those that have not been seen for a
                period of time based on an organization's business rules. It is often used to filter subject lists to
                exclude inactive subjects.
                Deceased subjects may also be marked as inactive for the same reasons, but may be active for some time after
                death. */
  active?: boolean;
  custom_fields?: {
    [key: string]: any;
  } | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
};
export type ListResponseDevice = {
  object?: "list";
  data?: (
    | DeviceGeneric
    | DeviceVitalThingsGuardianH10
    | DeviceVitalThingsSomnofySm100
  )[];
};
export type DeviceEmbed = "subject";
export type ResponseDevice = {
  data?:
    | DeviceGeneric
    | DeviceVitalThingsGuardianH10
    | DeviceVitalThingsSomnofySm100;
};
export type DeviceGenericCreate = {
  type: "generic";
  zone_id: string;
  virtual?: boolean;
  manufacturer?: string | null;
  product?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  name?: string | null;
  /** Device notes and comments */
  note: string | null;
  metadata?: {
    [key: string]: any;
  };
};
export type DeviceVitalThingsGuardianH10Register = {
  type: "vitalthings-guardian-h10";
  zone_id: string;
  serial_number: string;
  metadata?: {
    [key: string]: any;
  };
};
export type DeviceVitalThingsSomnofySm100Register = {
  type: "vitalthings-somnofy-sm100";
  zone_id: string;
  serial_number: string;
  metadata?: {
    [key: string]: any;
  };
};
export type NotFound = {
  detail?: string | null;
};
export type DeviceGenericUpdate = {
  type: "generic";
  zone_id?: string | null;
  subject_id?: string | null;
  virtual?: boolean | null;
  manufacturer?: string | null;
  product?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  name?: string | null;
  /** Device notes and comments */
  note?: string | null;
  metadata?: {
    [key: string]: any;
  };
};
export type VitalThingsGuardianH10SettingsUser2 = {
  time?: VitalThingsSomnofySm100SettingsUserTime;
  radar?: VitalThingsSomnofySm100SettingsUserRadar;
  schedule?: VitalThingsSomnofySm100SettingsUserScheduleItem[];
};
export type VitalThingsGuardianH10Settings2 = {
  user?: VitalThingsGuardianH10SettingsUser2;
};
export type DeviceVitalThingsGuardianH10Update = {
  type: "vitalthings-guardian-h10";
  zone_id?: string | null;
  subject_id?: string | null;
  name?: string | null;
  note?: string | null;
  metadata?: {
    [key: string]: any;
  };
  settings?: VitalThingsGuardianH10Settings2 | null;
};
export type VitalThingsSomnofySm100SettingsUser2 = {
  time?: VitalThingsSomnofySm100SettingsUserTime;
  display?: VitalThingsSomnofySm100SettingsUserDisplay;
  audio?: VitalThingsSomnofySm100SettingsUserAudio;
  radar?: VitalThingsSomnofySm100SettingsUserRadar;
  schedule?: VitalThingsSomnofySm100SettingsUserScheduleItem[];
  external_devices?: VitalThingsSomnofySm100SettingsUserExternalDevices;
};
export type VitalThingsSomnofySm100Settings2 = {
  user?: VitalThingsSomnofySm100SettingsUser2;
  device?: VitalThingsSomnofySm100SettingsDevice;
};
export type DeviceVitalThingsSomnofySm100Update = {
  type: "vitalthings-somnofy-sm100";
  zone_id?: string | null;
  subject_id?: string | null;
  name?: string | null;
  note?: string | null;
  metadata?: {
    [key: string]: any;
  };
  settings?: VitalThingsSomnofySm100Settings2 | null;
};
export type UserState = "pending" | "active" | "inactive";
export type UserRole =
  | "OWNER"
  | "ADMIN"
  | "MANAGER"
  | "MANAGER_LIMITED"
  | "DATA_READER"
  | "DATA_READER_LIMITED"
  | "SERVICE_MONITOR";
export type EmbeddedZones = {
  object?: "list";
  data?: Zone[];
};
export type User = {
  id: string;
  object?: "user";
  state: UserState;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  profession?: string | null;
  roles: UserRole[];
  zones?: EmbeddedZones | null;
  preferences?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
};
export type ListResponseUser = {
  object?: "list";
  data?: User[];
};
export type UserEmbed = "zones";
export type ResponseUser = {
  data?: User;
};
export type UserCreate = {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  profession?: string | null;
  roles?: UserRole[] | null;
  preferences?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type UserUpdate = {
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  profession?: string | null;
  roles?: UserRole[] | null;
  preferences?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type Result = "failed" | "success";
export type ActionResponse = {
  result: Result;
};
export type LiveMonitorItemState =
  | "device_offline"
  | "device_inactive"
  | "device_sleep_tracking_disabled"
  | "not_in_bed"
  | "awake_in_bed"
  | "asleep"
  | "failed"
  | "fall_detected";
export type LiveMonitorItemZone = {
  id: string;
  path: string;
  name: string;
};
export type LiveMonitorItemDevice = {
  id: string;
  type: string;
  serial_number?: string | null;
  name?: string | null;
};
export type LiveMonitorItemSubject = {
  id: string;
  identifier: string;
  sex?: Sex | null;
  /** The year of birth for the individual. */
  birth_year?: number | null;
};
export type LiveMonitorItemMetrics = {
  respiration_rate_pooled_mean?: number | null;
  respiration_rate_pool_size?: number;
  latest_movement_mean?: number | null;
  latest_spo2_mean?: number | null;
};
export type LiveMonitorItem = {
  state: LiveMonitorItemState;
  state_changed_at?: string | null;
  latest_epoch_timestamp?: string | null;
  zone: LiveMonitorItemZone;
  device: LiveMonitorItemDevice;
  subject?: LiveMonitorItemSubject | null;
  metrics?: LiveMonitorItemMetrics | null;
  updated_at: string;
};
export type ListResponseLiveMonitorItem = {
  object?: "list";
  data?: LiveMonitorItem[];
};
export type NightReportSubject = {
  id: string;
  identifier: string;
  sex?: Sex | null;
  /** The year of birth for the individual. */
  birth_year?: number | null;
};
export type NightReportDevice = {
  id: string;
  type: string;
  serial_number?: string | null;
  name?: string | null;
};
export type NightReportState =
  | "PRESENCE_AND_SLEEP"
  | "NO_PRESENCE"
  | "NO_SLEEP";
export type NightReportMetricBase = {
  /** The value for the parameter for the report night. */
  value: number;
  /** The baseline for the parameter. */
  baseline?: number | null;
  /** The difference between the value and the baseline. */
  deviation?: number | null;
  /** The deviation in percent. None if baseline=0. */
  deviation_pct?: number | null;
  /** Should the deviation be alerted? */
  deviation_alert?: boolean | null;
};
export type NightReport = {
  /** Subject metadata for the person the report is generated for. */
  subject?: NightReportSubject | null;
  /** Device metadata for the device used for the selected session. */
  device?: NightReportDevice | null;
  /** Session ID for the session the report is generated for. */
  session_id?: string | null;
  /** Start time of time night report. */
  timeframe_start: string;
  /** End time of time night report. */
  timeframe_end: string;
  /** Date of the night report. */
  report_date: string;
  /** Does the night include sleep data, other data or no data. */
  state: NightReportState;
  /** Is the report session still in progress or is it ended. */
  selected_session_is_in_progress?: boolean | null;
  /** How many nights were used to calculate the baselines for which deviations and alerts are derived. */
  baseline_night_count?: number | null;
  /** Metrics for respiration rate. */
  respiration_rate?: NightReportMetricBase | null;
  /** Metrics for epochs with movement percent. */
  movement?: NightReportMetricBase | null;
  /** Metrics for total time asleep. */
  time_asleep?: NightReportMetricBase | null;
  /** Metrics for no presence count. */
  out_of_bed?: NightReportMetricBase | null;
  /** Metrics for respiration sleep score. */
  sleep_score?: NightReportMetricBase | null;
};
export type ListResponseReport = {
  object?: "list";
  data?: NightReport[];
};
export type SessionState = "IN_PROGRESS" | "ENDED";
export type VitalThingsSomnofySm100SessionEpochData = {
  /** Timestamp for epoch start time. Same as BaseDataFragment.Environment.timestamp. */
  timestamp: string[];
  /** Mean of signal_quality (BaseData.Motion) [unitless, 0-10] */
  signal_quality_mean: number[];
  /** Mean respiration rate during epoch [RPM] */
  respiration_rate_mean: number[];
  /** Variance of respiration rate during epoch [RPM^2] */
  respiration_rate_var: number[];
  /** Mean of movement_fast (BaseData.Motion) during epoch [unitless, 0-100] */
  movement_fast_mean: number[];
  /** Percent of epoch with nonzero movement_fast (BaseData.Motion) [0-100%] */
  movement_fast_nonzero_pct?: number[] | null;
  /** Mean heart rate during epoch [BPM] */
  heart_rate_mean?: number[] | null;
  /** Variance of heart rate during epoch [BPM^2] */
  heart_rate_var?: number[] | null;
  /** Mean heart rate from external device during epoch [BPM] */
  external_heart_rate_mean?: number[] | null;
  /** Variance of heart rate from external device during epoch [BPM^2] */
  external_heart_rate_var?: number[] | null;
  /** Mean SpO2 from external device [0-100%] */
  external_spo2_mean?: number[] | null;
  /** Variance of SpO2 from external device during epoch */
  external_spo2_var?: number[] | null;
  /** Minimum value of SpO2 from external device during epoch [0-100%] */
  external_spo2_min?: number[] | null;
  /** Mean distance from sensor during epoch [m] */
  distance_mean: number[];
  /** Number of radar measurements in epoch */
  motion_data_count: number[];
  /** Mean ambient light during epoch [lux] */
  light_ambient_mean: number[];
  /** Mean sound amplitude during epoch [dBA] */
  sound_amplitude_mean: number[];
  /** Mean ambient temperature during epoch [deg C] */
  temperature_ambient_mean: number[];
  /** Mean air pressure during epoch [Pa] */
  pressure_mean: number[];
  /** Mean air humidity during epoch [0-100%] */
  humidity_mean: number[];
  /** Mean indoor air quality during epoch [unitless, 0-500] */
  indoor_air_quality_mean: number[];
  /** Length of epoch [s] */
  epoch_duration: number[];
  /** Sleep stage scored by the sleep stage classifier ML algorithm [0-7] */
  sleep_stage: number[];
};
export type VitalThingsSomnofySm100Session = {
  object?: "vitalthings-somnofy-sm100-session";
  id: string;
  state: SessionState;
  subject_id: string;
  device_serial_number: string;
  /** Number of epochs in the session [unitless] */
  epoch_count: number;
  /** Start time of the session (first measurement) */
  session_start: string;
  /** Session start in seconds after midnight (negative if before) [seconds] */
  relative_session_start: number;
  /** End time of the session (last measurement + 1s) */
  session_end: string;
  /** Time at last epoch */
  time_at_last_epoch: string;
  /** Intended sleep (last dimmed light or no presence before sleep onset) */
  time_at_intended_sleep: string;
  /** Intended wakeup (first brightened light or no presence after last wakeup) */
  time_at_intended_wakeup?: string | null;
  /** Time spent in undefined sleep stage, e.g. if data is missing [seconds] */
  time_in_undefined: number;
  /** When the first sleep in session happens */
  time_at_sleep_onset?: string | null;
  /** When the final wakeup in session happens */
  time_at_wakeup?: string | null;
  /** Midpoint between sleep onset and wakeup */
  time_at_midsleep?: string | null;
  /** Time from intended sleep to sleep onset [seconds] */
  sleep_onset_latency?: number | null;
  /** Time from sleep onset to wakeup [seconds] */
  sleep_period: number;
  /** Time between intended sleep and intended wakeup [seconds] */
  time_in_bed: number;
  /** Time spent asleep [seconds] */
  time_asleep: number;
  /** 100 * time_asleep / time_in_bed [0-100%] */
  sleep_efficiency: number;
  /** Time spent in light sleep [seconds] */
  time_in_light_sleep: number;
  /** Time spent in REM sleep [seconds] */
  time_in_rem_sleep: number;
  /** Time spent in deep sleep [seconds] */
  time_in_deep_sleep: number;
  /** Time with no presence (during sleep period) [seconds] */
  time_in_no_presence: number;
  /** Number of separate occurrences of no presence (during sleep period) [unitless] */
  number_of_times_no_presence: number;
  /** Time spent awake during sleep period [seconds] */
  time_wake_after_sleep_onset?: number | null;
  /** Number of times awake in sleep period [unitless] */
  number_of_times_awake: number;
  /** Number of times awake for >=5 consecutive epochs in sleep period [unitless] */
  number_of_times_awake_long: number;
  /** Sleep onset latency plus time from wakeup to intended wakeup [seconds] */
  time_wake_pre_post_sleep?: number | null;
  /** Time from sleep onset to first REM sleep [seconds] */
  time_from_sleep_onset_to_first_rem?: number | null;
  /** Mean movement during sleep period [unitless]. */
  movement_fast_during_sleep_period_mean?: number | null;
  /** Mean respiration rate (filtered) during non-REM sleep [RPM] */
  rpm_non_rem_filtered_mean?: number | null;
  /** Variance of EpochData.respiration_rate_mean during non-REM sleep [RPM^2] */
  rpm_non_rem_mean_var?: number | null;
  /** Current respiration rate baseline from User.SleepHistoryMetrics [RPM] */
  rpm_non_rem_baseline?: number | null;
  /** Current respiration rate baseline standard deviation from User.SleepHistoryMetrics [RPM] */
  rpm_non_rem_baseline_std?: number | null;
  /** Mean heart rate (filtered) during non-REM sleep [BPM] */
  heart_rate_non_rem_filtered_mean?: number | null;
  /** Mean heart rate during non-REM sleep [BPM] */
  heart_rate_non_rem_mean?: number | null;
  /** Mean heart rate from external device during non-REM sleep [BPM] */
  external_heart_rate_non_rem_filtered_mean?: number | null;
  /** Percent of epochs in session with movement [%] */
  epochs_with_movement_pct: number;
  /** Percent of epochs with movement during time in bed [%] */
  epochs_with_movement_during_time_in_bed_pct?: number | null;
  /** Percent of seconds in session with movement [%] */
  time_with_movement_pct?: number | null;
  /** Percent of seconds with movement during time in bed [%] */
  time_with_movement_during_time_in_bed_pct?: number | null;
  /** Number of sleep cycles >15 min, determined by the occurrence of REM sleep */
  sleep_cycles_count?: number | null;
  /** Whether wakeup day is a workday. Assumes workday is the same as weekday [Mon-Fri = True, Sat-Sun = False] */
  is_workday: boolean;
  /** MCTQ Chronotype: Midsleep on free days corrected for sleep debt [hours after midnight] */
  chronotype?: number | null;
  /** Difference between midsleep on free days and work days [hours] */
  social_jet_lag?: number | null;
  /** Previous chronotype minus midsleep of session [hours] */
  jet_lag?: number | null;
  /** Sleep Regularity Index (SRI) for the last 14 days [unitless, -100-100] */
  regularity?: number | null;
  /** Sleep score based on time in sleep stages and fragmentation [unitless, 0-100]. Adjusted for user demography. */
  sleep_score_standard: number;
  /** How fragmented the sleep is, based on 90 minute segments. Longer wake periods and fragmentation early in the night are punished harder. [unitless, 0(no fragmentation)-100] */
  sleep_fragmentation: number;
  /** Mean SpO2 from external device during session [0-100] */
  external_spo2_mean?: number | null;
  /** Minimum SpO2 from external device during session [0-100] */
  external_spo2_min?: number | null;
  /** Mean distance from device during epochs with sleep [m] */
  distance_during_sleep_mean?: number | null;
  /** Standard deviation of distance from device during epochs with sleep [m] */
  distance_during_sleep_std?: number | null;
  /** Mean air pressure during session [Pa] */
  air_pressure_filtered_mean: number;
  /** Mean ambient light during session [lux] */
  light_ambient_filtered_mean: number;
  /** Mean ambient light from last sleep to intended wakeup [lux] */
  light_ambient_at_wakeup_mean?: number | null;
  /** Mean sound amplitude during session [dBA] */
  sound_amplitude_filtered_mean: number;
  /** Mean sound amplitude during sleep [dBA] */
  sound_amplitude_during_sleep_mean?: number | null;
  /** Mean amplitude of sounds louder than 40 dBA during sleep [dBA] */
  sound_amplitude_during_sleep_filtered_for_noise_mean?: number | null;
  /** Mean sound amplitude during sleep without movement [dBA] */
  sound_amplitude_during_sleep_filtered_for_movement_mean?: number | null;
  /** Largest sound amplitude in the 5 last epochs before wakeup [dBA] */
  sound_amplitude_at_wakeup?: number | null;
  /** Number of epochs with sound amplitude > 45 dBA [unitless] */
  epochs_with_sound_spikes_during_sleep_count?: number | null;
  /** Number of awakenings coinciding with sound amplitude > mean + 10 dBA [unitless] */
  awakenings_caused_by_sound_count?: number | null;
  /** Mean ambient temperature during session [deg C] */
  temperature_filtered_mean?: number | null;
  /** Mean indoor air quality during session [unitless, 0-500] */
  indoor_air_quality_filtered_mean?: number | null;
  /** Mean air humidity during session [%] */
  air_humidity_filtered_mean?: number | null;
  epoch_data?: VitalThingsSomnofySm100SessionEpochData | null;
};
export type ListResponseVitalThingsSomnofySm100Session = {
  object?: "list";
  data?: VitalThingsSomnofySm100Session[];
};
export type SessionType = "vitalthings-somnofy-sm100-session";
export type Sort = "asc" | "desc";
export type ResponseVitalThingsSomnofySm100Session = {
  data?: VitalThingsSomnofySm100Session;
};
export type NotificationHandlerEmailConfiguration = {
  recipients: string[];
};
export type NotificationHandlerEmail = {
  type: "email";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration: NotificationHandlerEmailConfiguration;
  id: string;
  object?: "notification-handler.email";
};
export type NotificationHandlerNetNordicConfiguration = {
  api_base_url: string;
  client_id?: string;
  username: string;
  password: string;
};
export type NotificationHandlerNetNordic = {
  type: "netnordic";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration: NotificationHandlerNetNordicConfiguration;
  id: string;
  object?: "notification-handler.netnordic";
};
export type NotificationHandlerSensioConfiguration = {
  api_base_url: string;
  username: string;
  password: string;
  client_id: string;
  client_secret: string;
  grant_type?: "password";
};
export type NotificationHandlerSensio = {
  type: "sensio";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration: NotificationHandlerSensioConfiguration;
  id: string;
  object?: "notification-handler.sensio";
};
export type NotificationHandlerSkyresponseConfiguration = {};
export type NotificationHandlerSkyresponse = {
  type: "skyresponse";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration?: NotificationHandlerSkyresponseConfiguration | null;
  id: string;
  object?: "notification-handler.skyresponse";
};
export type TimeRestriction = {
  start: string;
  end: string;
};
export type NotificationHandlerSmsConfigurationRecipient = {
  phone_number: string;
  time_restriction?: TimeRestriction | null;
};
export type NotificationHandlerSmsConfiguration = {
  recipients: NotificationHandlerSmsConfigurationRecipient[];
};
export type NotificationHandlerSms = {
  type: "sms";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration: NotificationHandlerSmsConfiguration;
  id: string;
  object?: "notification-handler.sms";
};
export type NotificationHandlerWebhookConfiguration = {
  url: string;
  headers?: {
    [key: string]: string;
  } | null;
};
export type NotificationHandlerWebhook = {
  type: "webhook";
  zone_id: string;
  description: string;
  enabled?: boolean;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  created_at: string;
  updated_at: string;
  configuration: NotificationHandlerWebhookConfiguration;
  id: string;
  object?: "notification-handler.webhook";
};
export type NotificationHandlerResponseModels =
  | ({
      type: "email";
    } & NotificationHandlerEmail)
  | ({
      type: "netnordic";
    } & NotificationHandlerNetNordic)
  | ({
      type: "sensio";
    } & NotificationHandlerSensio)
  | ({
      type: "skyresponse";
    } & NotificationHandlerSkyresponse)
  | ({
      type: "sms";
    } & NotificationHandlerSms)
  | ({
      type: "webhook";
    } & NotificationHandlerWebhook);
export type ListResponseNotificationHandler = {
  object?: "list";
  data?: NotificationHandlerResponseModels[];
};
export type NotificationHandlerType =
  | "sms"
  | "email"
  | "webhook"
  | "sensio"
  | "skyresponse"
  | "netnordic";
export type ReponseNotificationHandler = {
  data?: NotificationHandlerResponseModels;
};
export type NotificationHandlerEmailCreate = {
  type: "email";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration: NotificationHandlerEmailConfiguration;
};
export type NotificationHandlerNetNordicCreate = {
  type: "netnordic";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration: NotificationHandlerNetNordicConfiguration;
};
export type NotificationHandlerSensioCreate = {
  type: "sensio";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration: NotificationHandlerSensioConfiguration;
};
export type NotificationHandlerSkyresponseCreate = {
  type: "skyresponse";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration?: NotificationHandlerSkyresponseConfiguration | null;
};
export type NotificationHandlerSmsConfiguration2 = {
  recipients: NotificationHandlerSmsConfigurationRecipient[];
};
export type NotificationHandlerSmsCreate = {
  type: "sms";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration: NotificationHandlerSmsConfiguration2;
};
export type NotificationHandlerWebhookCreate = {
  type: "webhook";
  zone_id: string;
  description: string;
  enabled?: boolean;
  configuration: NotificationHandlerWebhookConfiguration;
};
export type NotificationHandlerCreate =
  | ({
      type: "email";
    } & NotificationHandlerEmailCreate)
  | ({
      type: "netnordic";
    } & NotificationHandlerNetNordicCreate)
  | ({
      type: "sensio";
    } & NotificationHandlerSensioCreate)
  | ({
      type: "skyresponse";
    } & NotificationHandlerSkyresponseCreate)
  | ({
      type: "sms";
    } & NotificationHandlerSmsCreate)
  | ({
      type: "webhook";
    } & NotificationHandlerWebhookCreate);
export type NotificationHandlerEmailUpdate = {
  type: "email";
  enabled?: boolean;
};
export type NotificationHandlerNetNordicUpdate = {
  type: "netnordic";
  enabled?: boolean;
};
export type NotificationHandlerSensioUpdate = {
  type: "sensio";
  enabled?: boolean;
};
export type NotificationHandlerSkyresponseUpdate = {
  type: "skyresponse";
  enabled?: boolean;
};
export type NotificationHandlerSmsUpdate = {
  type: "sms";
  enabled?: boolean;
};
export type NotificationHandlerWebhookUpdate = {
  type: "webhook";
  enabled?: boolean;
};
export type NotificationHandlerUpdateModels =
  | ({
      type: "email";
    } & NotificationHandlerEmailUpdate)
  | ({
      type: "netnordic";
    } & NotificationHandlerNetNordicUpdate)
  | ({
      type: "sensio";
    } & NotificationHandlerSensioUpdate)
  | ({
      type: "skyresponse";
    } & NotificationHandlerSkyresponseUpdate)
  | ({
      type: "sms";
    } & NotificationHandlerSmsUpdate)
  | ({
      type: "webhook";
    } & NotificationHandlerWebhookUpdate);
export type NotificationHandlerTestResult = {
  successful: boolean;
  message?: string | null;
  detail?: string | null;
};
export type NotificationHandlerTestResponse = {
  notification_handler_id: string;
  entity_id: string;
  rule_id: string;
  notification_text: string;
  results: NotificationHandlerTestResult[];
};
export type ResponseNotificationHandlerTestResponse = {
  data?: NotificationHandlerTestResponse;
};
export type NotificationHandlerTest = {
  entity_id: string;
  rule_id: string;
  notification_text: string;
};
export type RuleDeviceEventConditions = {
  /** Events to match. Either full path or wildcard. Examples: 'vitalthings.somnofy.sm100.system.tamper'
            or 'vitalthings.somnofy.sm100.*' */
  type: string[];
};
export type RuleDeviceEvent = {
  id: string;
  object?: "rule.device-event";
  type: "device.event";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions: RuleDeviceEventConditions;
  created_at: string;
  updated_at: string;
};
export type RuleDeviceOfflineConditionsPreset = "default";
export type RuleDeviceOfflineConditions = {
  /** Time in seconds since last seen */
  time_since_last_seen_gte?: number;
};
export type RuleDeviceOfflineConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleDeviceOffline = {
  id: string;
  object?: "rule.device-offline";
  type: "device.offline";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  conditions_preset?: RuleDeviceOfflineConditionsPreset | null;
  conditions?: RuleDeviceOfflineConditions | null;
  configuration?: RuleDeviceOfflineConfiguration;
  created_at: string;
  updated_at: string;
};
export type RuleFallDetectedConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleFallDetected = {
  id: string;
  object?: "rule.fall_detected";
  type: "subject.fall-detected";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  configuration?: RuleFallDetectedConfiguration;
  created_at: string;
  updated_at: string;
};
export type RuleAwakeConditionsPreset = "default";
export type RuleAwakeConditionsOkToAlert = {
  /** Time in epochs with consecutive awake to transition to alert state */
  awake_time_epochs_gte?: number;
};
export type RuleAwakeConditionsAlertToOk = {
  /** Time in epochs with consecutive sleep before state transitions from alert to ok */
  asleep_time_epochs_gte?: number;
};
export type RuleAwakeConditions = {
  /** Minimum time in epochs with presence (cumulative) before the rule is active */
  initial_presence_time_epochs_gte?: number;
  ok_to_alert?: RuleAwakeConditionsOkToAlert;
  alert_to_ok?: RuleAwakeConditionsAlertToOk;
};
export type RuleAwakeConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleAwake = {
  id: string;
  object?: "rule.awake";
  type: "subject.session.epochs.awake";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleAwakeConditionsPreset | null;
  conditions?: RuleAwakeConditions | null;
  configuration?: RuleAwakeConfiguration;
  created_at: string;
  updated_at: string;
};
export type RuleMovementConditionsPreset = "default";
export type RuleMovementConditions = {
  /** Minimum time in epochs with presence (cumulative) before the rule is active */
  initial_presence_time_epochs_gte?: number;
  /** Over how many epochs to calculate the mean */
  movement_mean_time_epochs_gte?: number;
  /** Alert deviation threshold for mean movement (dimensionless, 0-100) */
  movement_mean_gte?: number;
};
export type RuleMovementConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleMovement = {
  id: string;
  object?: "rule.movement";
  type: "subject.session.epochs.movement";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleMovementConditionsPreset | null;
  conditions?: RuleMovementConditions | null;
  configuration?: RuleMovementConfiguration;
  created_at: string;
  updated_at: string;
};
export type RuleNoPresenceConditionsPreset = "default";
export type RuleNoPresenceConditionsOkToAlert = {
  /** Time in epochs with consecutive no presence to transition to alert state */
  no_presence_time_epochs_gte?: number;
};
export type RuleNoPresenceConditionsAlertToOk = {
  /** Time in epochs with consecutive presence before state transitions from alert to ok */
  presence_time_epochs_gte?: number;
};
export type RuleNoPresenceConditions = {
  /** Minimum time in epochs with presence (cumulative) before the rule is active */
  initial_presence_time_epochs_gte?: number;
  ok_to_alert?: RuleNoPresenceConditionsOkToAlert;
  alert_to_ok?: RuleNoPresenceConditionsAlertToOk;
};
export type RuleNoPresenceConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleNoPresence = {
  id: string;
  object?: "rule.no-presence";
  type: "subject.session.epochs.no-presence";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleNoPresenceConditionsPreset | null;
  conditions?: RuleNoPresenceConditions | null;
  configuration?: RuleNoPresenceConfiguration;
  created_at: string;
  updated_at: string;
};
export type RuleSoundLevelConditionsPreset = "default";
export type RuleSoundLevelConditions = {
  /** Minimum time in epochs with presence (cumulative) before the rule is active */
  initial_presence_time_epochs_gte?: number;
  /** Upper threshold for sound alert (float, dB) */
  sound_level_gte?: number;
};
export type RuleSoundLevelConfiguration = {
  execute_actions_on_alert_to_ok?: boolean;
};
export type RuleSoundLevel = {
  id: string;
  object?: "rule.sound-level";
  type: "subject.session.epochs.sound-level";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleSoundLevelConditionsPreset | null;
  conditions?: RuleSoundLevelConditions | null;
  configuration?: RuleSoundLevelConfiguration;
  created_at: string;
  updated_at: string;
};
export type CronSchedule = {
  /** A string representing a Crontab pattern.
            This may get pretty advanced, like hour='*\/3' (for every three hours)
            or hour='0,8-17/2' (at midnight, and every two hours during office hours) */
  hour?: string | null;
  /** A string representing a Crontab pattern. This may get pretty advanced,
            like minute='*\/15' (for every quarter) or minute='1,13,30-45,50-59/2' */
  minute?: string | null;
  timezone?: string | null;
};
export type RuleMultiDayRespirationRateDeviation = {
  id: string;
  object?: "rule.multi-day-respiration-rate-deviation";
  type: "subject.sessions.respiration-rate-trend-deviation";
  description?: string | null;
  enabled?: boolean;
  zone_id?: string | null;
  subject_id?: string | null;
  device_id?: string | null;
  inheritance_enabled: boolean;
  inherited?: boolean | null;
  schedule: CronSchedule;
  created_at: string;
  updated_at: string;
};
export type RuleResponseModels =
  | ({
      type: "device.event";
    } & RuleDeviceEvent)
  | ({
      type: "device.offline";
    } & RuleDeviceOffline)
  | ({
      type: "subject.fall-detected";
    } & RuleFallDetected)
  | ({
      type: "subject.session.epochs.awake";
    } & RuleAwake)
  | ({
      type: "subject.session.epochs.movement";
    } & RuleMovement)
  | ({
      type: "subject.session.epochs.no-presence";
    } & RuleNoPresence)
  | ({
      type: "subject.session.epochs.sound-level";
    } & RuleSoundLevel)
  | ({
      type: "subject.sessions.respiration-rate-trend-deviation";
    } & RuleMultiDayRespirationRateDeviation);
export type ListResponseRule = {
  object?: "list";
  data?: RuleResponseModels[];
};
export type RuleType =
  | "subject.session.epochs.no-presence"
  | "subject.session.epochs.sound-level"
  | "subject.session.epochs.awake"
  | "subject.session.epochs.movement"
  | "subject.fall-detected"
  | "subject.sessions.respiration-rate-trend-deviation"
  | "device.offline"
  | "device.event";
export type ReponseMonitoringRule = {
  data?: RuleResponseModels;
};
export type RuleDeviceEventCreate = {
  type: "device.event";
  description?: string | null;
  enabled?: boolean;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions: RuleDeviceEventConditions;
  entity_id: string;
};
export type RuleDeviceOfflineCreate = {
  type: "device.offline";
  description?: string | null;
  enabled?: boolean;
  conditions_preset?: RuleDeviceOfflineConditionsPreset | null;
  conditions?: RuleDeviceOfflineConditions | null;
  configuration?: RuleDeviceOfflineConfiguration;
  entity_id: string;
};
export type RuleFallDetectedCreate = {
  type: "subject.fall-detected";
  description?: string | null;
  enabled?: boolean;
  configuration?: RuleFallDetectedConfiguration;
  entity_id: string;
};
export type RuleAwakeCreate = {
  type: "subject.session.epochs.awake";
  description?: string | null;
  enabled?: boolean;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleAwakeConditionsPreset | null;
  conditions?: RuleAwakeConditions | null;
  configuration?: RuleAwakeConfiguration;
  entity_id: string;
};
export type RuleMovementCreate = {
  type: "subject.session.epochs.movement";
  description?: string | null;
  enabled?: boolean;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleMovementConditionsPreset | null;
  conditions?: RuleMovementConditions | null;
  configuration?: RuleMovementConfiguration;
  entity_id: string;
};
export type RuleNoPresenceCreate = {
  type: "subject.session.epochs.no-presence";
  description?: string | null;
  enabled?: boolean;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleNoPresenceConditionsPreset | null;
  conditions?: RuleNoPresenceConditions | null;
  configuration?: RuleNoPresenceConfiguration;
  entity_id: string;
};
export type RuleSoundLevelCreate = {
  type: "subject.session.epochs.sound-level";
  description?: string | null;
  enabled?: boolean;
  /** The timeframe this rule should be active, null
            or { "start": "00:00", "end": "00:00" } means 24/7. */
  time_restriction?: TimeRestriction | null;
  conditions_preset?: RuleSoundLevelConditionsPreset | null;
  conditions?: RuleSoundLevelConditions | null;
  configuration?: RuleSoundLevelConfiguration;
  entity_id: string;
};
export type RuleMultiDayRespirationRateDeviationCreate = {
  type: "subject.sessions.respiration-rate-trend-deviation";
  description?: string | null;
  enabled?: boolean;
  schedule: CronSchedule;
  entity_id: string;
};
export type RuleCreateModels =
  | ({
      type: "device.event";
    } & RuleDeviceEventCreate)
  | ({
      type: "device.offline";
    } & RuleDeviceOfflineCreate)
  | ({
      type: "subject.fall-detected";
    } & RuleFallDetectedCreate)
  | ({
      type: "subject.session.epochs.awake";
    } & RuleAwakeCreate)
  | ({
      type: "subject.session.epochs.movement";
    } & RuleMovementCreate)
  | ({
      type: "subject.session.epochs.no-presence";
    } & RuleNoPresenceCreate)
  | ({
      type: "subject.session.epochs.sound-level";
    } & RuleSoundLevelCreate)
  | ({
      type: "subject.sessions.respiration-rate-trend-deviation";
    } & RuleMultiDayRespirationRateDeviationCreate);
export type RuleConditionsPresetDeviceOffline = {
  id: string;
  type: "device.offline.conditions";
  name: string;
  preset: RuleDeviceOfflineConditions;
};
export type RuleConditionsPresetAwake = {
  id: string;
  type: "subject.session.epochs.awake.conditions";
  name: string;
  preset: RuleAwakeConditions;
};
export type RuleConditionsPresetMovement = {
  id: string;
  type: "subject.session.epochs.movement.conditions";
  name: string;
  preset: RuleMovementConditions;
};
export type RuleConditionsPresetNoPresence = {
  id: string;
  type: "subject.session.epochs.no-presence.conditions";
  name: string;
  preset: RuleNoPresenceConditions;
};
export type RuleConditionsPresetSoundLevel = {
  id: string;
  type: "subject.session.epochs.sound-level.conditions";
  name: string;
  preset: RuleSoundLevelConditions;
};
export type RulePreset =
  | ({
      type: "device.offline.conditions";
    } & RuleConditionsPresetDeviceOffline)
  | ({
      type: "subject.session.epochs.awake.conditions";
    } & RuleConditionsPresetAwake)
  | ({
      type: "subject.session.epochs.movement.conditions";
    } & RuleConditionsPresetMovement)
  | ({
      type: "subject.session.epochs.no-presence.conditions";
    } & RuleConditionsPresetNoPresence)
  | ({
      type: "subject.session.epochs.sound-level.conditions";
    } & RuleConditionsPresetSoundLevel);
export type ListResponseRulePreset = {
  object?: "list";
  data?: RulePreset[];
};
export type RulePresetType = "conditions";
export type RuleDeviceEventUpdate = {
  type: "device.event";
  enabled?: boolean;
};
export type RuleDeviceOfflineUpdate = {
  type: "device.offline";
  enabled?: boolean;
};
export type RuleFallDetectedUpdate = {
  type: "subject.fall-detected";
  enabled?: boolean;
};
export type RuleAwakeUpdate = {
  type: "subject.session.epochs.awake";
  enabled?: boolean;
};
export type RuleMovementUpdate = {
  type: "subject.session.epochs.movement";
  enabled?: boolean;
};
export type RuleNoPresenceUpdate = {
  type: "subject.session.epochs.no-presence";
  enabled?: boolean;
};
export type RuleSoundLevelUpdate = {
  type: "subject.session.epochs.sound-level";
  enabled?: boolean;
};
export type RuleMultiDayRespirationRateDeviationUpdate = {
  type: "subject.sessions.respiration-rate-trend-deviation";
  enabled?: boolean;
};
export type RuleUpdateModels =
  | ({
      type: "device.event";
    } & RuleDeviceEventUpdate)
  | ({
      type: "device.offline";
    } & RuleDeviceOfflineUpdate)
  | ({
      type: "subject.fall-detected";
    } & RuleFallDetectedUpdate)
  | ({
      type: "subject.session.epochs.awake";
    } & RuleAwakeUpdate)
  | ({
      type: "subject.session.epochs.movement";
    } & RuleMovementUpdate)
  | ({
      type: "subject.session.epochs.no-presence";
    } & RuleNoPresenceUpdate)
  | ({
      type: "subject.session.epochs.sound-level";
    } & RuleSoundLevelUpdate)
  | ({
      type: "subject.sessions.respiration-rate-trend-deviation";
    } & RuleMultiDayRespirationRateDeviationUpdate);
export type EntityType = "subject" | "device";
export type RuleState = "ok" | "alert" | "pending";
export type RuleMonitorState = {
  state?: RuleState;
  detail?: string | null;
  timestamp?: string | null;
  alarm_id?: string | null;
  updated_at?: string;
  latest_state_transition_at?: string | null;
};
export type EventDataRule = {
  id: string;
  type: RuleType;
  time_restriction?: {
    [key: string]: any;
  } | null;
  conditions_preset?: string | null;
  conditions?: {
    [key: string]: any;
  } | null;
  configuration?: {
    [key: string]: any;
  } | null;
  entity_type: EntityType;
  entity_id: string;
  previous_state?: RuleMonitorState | null;
  current_state?: RuleMonitorState | null;
};
export type NotificationLogActionResult = {
  timestamp: string;
  type: string;
  type_id: string;
  successful: boolean;
  message: string;
  detail?: string | null;
};
export type NotificationLog = {
  id: string;
  object?: "notification-log";
  zone_id?: string | null;
  zone_name?: string | null;
  subject_id?: string | null;
  subject_identifier?: string | null;
  device_id?: string | null;
  device_serial_number?: string | null;
  event_id: string;
  rule_id?: string | null;
  rule?: EventDataRule | null;
  actions?: NotificationLogActionResult[];
  created_at?: string;
  updated_at?: string;
};
export type ListResponseNotificationLog = {
  object?: "list";
  data?: NotificationLog[];
};
export const {
  useFindTenantByIdTenantsIdGetQuery,
  useListZonesZonesGetQuery,
  useCreateZoneZonesPostMutation,
  useListZoneTreeZonesTreeGetQuery,
  useFindZoneByIdZonesIdGetQuery,
  useUpdateZoneZonesIdPatchMutation,
  useDeleteZoneZonesIdDeleteMutation,
  useZoneParentZonesIdParentGetQuery,
  useListZoneChildrenZonesIdChildrenGetQuery,
  useListZoneDescendantsZonesIdDescendantsGetQuery,
  useListZoneAncestorsZonesIdAncestorsGetQuery,
  useZoneTenantZonesIdTenantGetQuery,
  useListSubjectsSubjectsGetQuery,
  useCreateSubjectSubjectsPostMutation,
  useFindSubjectByIdSubjectsIdGetQuery,
  useUpdateSubjectSubjectsIdPatchMutation,
  useDeleteSubjectSubjectsIdDeleteMutation,
  useListDevicesDevicesGetQuery,
  useRegisterOrCreateADeviceDevicesPostMutation,
  useFindDeviceByIdDevicesIdGetQuery,
  useUpdateDeviceDevicesIdPatchMutation,
  useDeleteDeviceDevicesIdDeleteMutation,
  useListUsersUsersGetQuery,
  useCreateUserUsersPostMutation,
  useFindUserByIdUsersIdGetQuery,
  useUpdateUserUsersIdPatchMutation,
  useDeleteUserUsersIdDeleteMutation,
  useResetPasswordUsersIdResetPasswordPostMutation,
  useListUserZonesUsersIdZonesGetQuery,
  useAddUserZoneAssociationUsersUserIdZonesZoneIdPostMutation,
  useRemoveUserZoneAssociationUsersUserIdZonesZoneIdDeleteMutation,
  useLiveMonitoringLiveMonitoringGetQuery,
  useGenerateReportsReportsGetQuery,
  useListSessionsSessionsGetQuery,
  useFindSessionSessionsSessionIdGetQuery,
  useListNotificationHandlersNotificationHandlersGetQuery,
  useCreateNotificationHandlerNotificationHandlersPostMutation,
  useFindNotificationHandlerNotificationHandlersIdGetQuery,
  useUpdateNotificationHandlerNotificationHandlersIdPatchMutation,
  useDeleteNotificationHandlerNotificationHandlersIdDeleteMutation,
  useTestNotificationHandlerNotificationHandlersIdTestPostMutation,
  useListRulesRulesGetQuery,
  useCreateRuleRulesPostMutation,
  useListRulePresetsRulesPresetsGetQuery,
  useFindRuleRulesIdGetQuery,
  useUpdateRuleRulesIdPatchMutation,
  useDeleteRuleRulesIdDeleteMutation,
  useListLogsNotificationLogsGetQuery,
} = injectedRtkApi;
